/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumnperson2Inputs */

const en_signupscolumnperson2 = /** @type {(inputs: Signupscolumnperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

const de_signupscolumnperson2 = /** @type {(inputs: Signupscolumnperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

/**
* | output |
* | --- |
* | "Person" |
*
* @param {Signupscolumnperson2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumnperson2 = /** @type {((inputs?: Signupscolumnperson2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumnperson2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumnperson2(inputs)
	return de_signupscolumnperson2(inputs)
});
export { signupscolumnperson2 as "signupsColumnPerson" }